import { render, staticRenderFns } from "./VacancyCard.vue?vue&type=template&id=1caa85b6"
import script from "./VacancyCard.vue?vue&type=script&lang=js"
export * from "./VacancyCard.vue?vue&type=script&lang=js"
import style0 from "./VacancyCard.vue?vue&type=style&index=0&id=1caa85b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports